var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 10.1885V13.9995",
    stroke: "#155DFC",
    strokeWidth: 1.99988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 2V5",
    stroke: "#155DFC",
    strokeWidth: 1.99988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 12.9998V6.99976C18.9998 6.46932 18.789 5.96061 18.414 5.58554C18.0389 5.21047 17.5302 4.99976 16.9998 4.99976H6.99976C6.46932 4.99976 5.96061 5.21047 5.58554 5.58554C5.21047 5.96061 4.99976 6.46932 4.99976 6.99976V12.9998",
    stroke: "#155DFC",
    strokeWidth: 1.99988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3789 19.9989C20.4545 18.1836 21.0145 16.1093 20.9988 13.9993L12.8112 10.3605C12.5556 10.2469 12.279 10.1882 11.9993 10.1882C11.7196 10.1882 11.443 10.2469 11.1873 10.3605L2.99983 13.9993C2.95354 16.8428 3.95349 19.6042 5.80966 21.7588",
    stroke: "#155DFC",
    strokeWidth: 1.99988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.9987C2.59996 21.4987 3.19993 21.9987 4.49985 21.9987C6.9997 21.9987 6.9997 19.9988 9.49956 19.9988C10.7995 19.9988 11.3994 20.4987 11.9994 20.9987C12.5994 21.4987 13.1993 21.9987 14.4993 21.9987C16.9991 21.9987 16.9991 19.9988 19.499 19.9988C20.7989 19.9988 21.3989 20.4987 21.9988 20.9987",
    stroke: "#155DFC",
    strokeWidth: 1.99988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.cd20861c436f6e6b4d334d8ab3705470.svg";
export { ForwardRef as ReactComponent };